// extracted by mini-css-extract-plugin
export default {"pageWrapper":"financialLog_pageWrapper__B4qvZ","blockWrapper":"financialLog_blockWrapper__Gjhob","title":"financialLog_title__bGpdn"};